import React, { useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './dialog';
import { Button } from './button';

/**
 * Confirmación de algo que no se deshace solo. El foco arranca en Cancelar.
 *
 * Vive aquí, y no dentro de Drive, porque el criterio tiene que ser UNO en todo el producto: antes
 * quitar el logo de un dominio preguntaba y desactivar el segundo factor —o publicar un documento
 * en Internet— no preguntaba nada. La regla que sigue el producto es: se pregunta cuando la acción
 * quita un acceso, concede uno nuevo o destruye algo que no se puede recuperar desde la interfaz.
 *
 * `testId` conserva por defecto el valor que ya usaba Drive: es contrato del E2E (regla 7).
 */
export function DialogoConfirmar({
  open,
  titulo,
  mensaje,
  boton = 'Eliminar',
  onConfirmar,
  onOpenChange,
  testId = 'drive-dialogo-confirmar',
  tono = 'peligro',   // 'normal' para lo que no destruye nada («Enviar así», «Reindexar»): botón de acento, no rojo (R12)
}) {
  const cancelar = useRef(null);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[420px]"
        data-testid={testId}
        onOpenAutoFocus={(e) => { e.preventDefault(); cancelar.current?.focus(); }}
      >
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription style={{ color: 'var(--text-2)' }}>{mensaje}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button ref={cancelar} variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button
            style={{ background: tono === 'normal' ? 'var(--accent)' : 'var(--danger)', color: '#fff' }}
            onClick={() => { onOpenChange(false); onConfirmar(); }}
            data-testid="drive-confirmar-eliminar"
          >
            {boton}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DialogoConfirmar;
